<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="row">
  <div class="col-md-3" style="height: 91vh;">
    <div class="d-flex mb-3">
      <img src="../../assets/img/myTask.svg" height="32px;" alt="mytask">&nbsp;
      <label for="email" style="color: #232323;font-size: 20px;">My Tasks</label>
      ({{totalCount}})
    </div>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="background-color: unset;"
      class="myTrainingLeftPlace">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
        [ngClass]="{ 'background-highlight': activeNode === node }" (click)="openLeftSideGridFunc(node)"
        (keydown.enter)="openLeftSideGridFunc(node)"
        [matTreeNodePaddingIndent]="node.item.includes('My Trainings') ? '10' : '15'">
        <span style="cursor: pointer;color:#0F3659;">
          <img *ngIf="activeNode === node" src="../../assets/img/highnlight.svg" alt="highlight" height="10px"
            class="me-1">
          <img *ngIf="node.item.includes('My Trainings')" lass="svg_dimension"
            src="../../assets/img/training_module/my-trainings.svg" alt="Trainings" />
          {{node.item}}
        </span>
        <div class="page-loading-shade" *ngIf="node.isLoading">
          <app-custom-spinner *ngIf="node.isLoading"></app-custom-spinner>
        </div>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodeToggle
        [matTreeNodePaddingIndent]="10">
        <span *ngIf="node.item.includes('My Tasks')">
          <b style="font-size: 15px;cursor: pointer;">{{node.item}}</b>
        </span>

        <span *ngIf="!node.item.includes('My Tasks')" style="cursor: pointer;color:#0F3659;width: 78%;">
          <svg *ngIf="node.item.includes('Training')" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 20 20" fill="none">
            <path
              d="M2 18L2.00034 14.9997C2.00052 13.3429 3.34361 12 5.00034 12H10.5M14 12.6429L16 10.5M16 10.5L18 12.6429M16 10.5V16M14.5 2C15.7135 2.68023 16.5 3.77073 16.5 5C16.5 6.22927 15.7135 7.31977 14.5 8M12 5C12 6.65685 10.6569 8 9 8C7.34314 8 6 6.65685 6 5C6 3.34315 7.34314 2 9 2C10.6569 2 12 3.34315 12 5Z"
              stroke="#0F3659" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <svg *ngIf="node.item.includes('Document')" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 20 20" fill="none">
            <path
              d="M2.00086 7.0139L2.00078 14.6175C2.00077 15.7221 2.8962 16.6175 4.00078 16.6175L15.9997 16.6175C17.1043 16.6176 17.9997 15.7222 17.9997 14.6176L18 6.84372C18 6.29142 17.5523 5.84369 17 5.84369H10.0697L7.76555 3.38232H3.00038C2.44794 3.38232 2.00017 3.82964 2.00034 4.38207C2.00058 5.16753 2.00086 6.2523 2.00086 7.0139Z"
              stroke="#0F3659" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <img *ngIf="node.item.includes('Audit')" lass="svg_dimension" style="height: 20px;"
            src="../../assets/img/Audit_cr.svg" alt="" alt="" />

          <svg *ngIf="node.item.includes('Change Request')" width="16" height="16" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
              stroke-width="1" stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <img *ngIf="node.item.includes('Feedback')" src="../../assets/img/feedback.png" class="svg_dimension" alt=""
            style="height: 20px;">

          <img *ngIf="node.item.includes('Business Process Setup')" src="../../assets/img/formSetup.png"
            class="svg_dimension" alt="" style="height: 20px;">

          <img *ngIf="node.item.includes('Corrective And Preventive Actions')" class="svg_dimension"
            style="height: 20px;" src="../../assets/img/CAPA.svg" alt="" />

          <img *ngIf="node.item.includes('Deviation')" class="svg_dimension" style="height: 20px;"
            src="../../assets/img/Deviations.svg" alt="" />

          <img *ngIf="node.item.includes('Customer Complaint')" class="svg_dimension" style="height: 20px;"
            src="../../assets/img/Customer Complaints.svg" alt="" />

          <img *ngIf="node.item.includes('Incident')" class="svg_dimension" style="height: 20px;"
            src="../../assets/img/investigation.png" alt="" />

          <img *ngIf="node.item.includes('Quality Issue')" class="svg_dimension" style="height: 20px;"
            src="../../assets/img/Quality Issues.svg" alt="" />

          <img *ngIf="node.item.includes('Out Of Specification')" class="svg_dimension"
            src="../../assets/img/specification.png" alt="" width="20" height="20" />

          <img *ngIf="node.item.includes('User Deactivation Approval')" src="../../assets/img/profile.png"
            alt="Deactivation" width="20" height="20">

          <svg *ngIf="node.item.includes('Forms and Logs')" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 24 25" fill="none">
            <path
              d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z"
              stroke="#0F3659" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          {{node.item}}
        </span>
        <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <div class="page-loading-shade" *ngIf="node.isLoading">
          <app-custom-spinner *ngIf="node.isLoading"></app-custom-spinner>
        </div>
      </mat-tree-node>
    </mat-tree>
  </div>

  <div class="col-md-9">
    <mat-tab-group mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex"
      *ngIf="clickedData && clickedData.title"> >
      <mat-tab id="myTask" label="My Task">
        <ng-template mat-tab-label>
          <span class="gridName">{{clickedData.subModule}} - {{status}}</span>
        </ng-template>

        <div style="padding: 10px;" *ngIf="clickedData.title != undefined">
          <div
            *ngIf="clickedData.subModule !='Document Withdrawal' && clickedData.subModule !='Document Extension' && clickedData.subModule != 'Document Destruction'">
            <div>
              <div class="d-flex justify-content-between mt-2">
                <div class="d-flex align-items-center px-3">
                  <div class="dropdown">
                  </div>
                </div>
                <div class="d-flex gap-3">
                  <div class="d-flex" id="header-container">
                    <div class="">
                      <div class="action-buttons-container d-flex gap-2"
                        *ngIf="showvulkreviewbtn && (status == 'Pending Schedule Approval' || status == 'Pending Plan Approval')">
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                          (click)="bulkReviewApprove()" (keydown.enter)="bulkReviewApprove()">
                          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px"
                            alt="add new" />
                          <span class="reload_text text-white" *ngIf="status=='Pending Schedule Approval'">
                            Bulk Schedule Approval
                          </span>
                          <span class="reload_text text-white" *ngIf="status=='Pending Plan Approval'">
                            Bulk Plan Approval
                          </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button *ngIf="clickedData.title == 'Training' && this.multiArray.length > 0" type="submit"
                        style="margin-top: 1px; margin-bottom: 1px; margin-left:-10%;color:white;"
                        class="addIconContiner" (click)="unlockTrainings()">
                        Unlock
                      </button>
                    </div>
                    <div class="">
                      <div class="search-container">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" class="form-control search_input" style="font-size: 12px"
                          placeholder="Search here..." [(ngModel)]="searchValue" (ngModelChange)="onSearchChange()" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-container">
              <table class="dynamic-table-container" aria-describedby="table-description">
                <thead>
                  <th style="min-width: 80px; text-align: center;"
                    *ngIf="clickedData.title == 'Training' && (searchValue=='' || searchValue==null)">
                    <div style="display: flex; justify-content: center; align-items: center;">
                      <input id="searchParentCheckBox" type="checkbox" style="zoom: 1.2;" (change)="selectAll($event)">
                    </div>
                  </th>
                  <th style="min-width: 80px; text-align: center;"
                    *ngIf="clickedData.title == 'Training' && searchValue!='' && searchValue!=null">
                  </th>
                  <th *ngIf="clickedData.title != 'Training'" style="min-width: 60px; text-align: center;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                    <div style="display: flex;">
                      <div>
                        <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                    </div>
                  </th>
                  <ng-container *ngIf="clickedData.title != 'User Deactivation Approval'">
                    <th
                      *ngIf="clickedData.title != 'Training' && !clickedData.title.includes('Forms and Logs') && clickedData.title != 'Feedback'"
                      [ngStyle]="{'min-width': '180px','max-width': '180px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{clickedData.title}} No.</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th *ngIf="clickedData.title.includes('Forms and Logs') || clickedData.title =='Feedback'"
                      [ngStyle]="{'min-width': '240px','max-width': '240px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{clickedData.title}} Name</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th *ngIf="clickedData.title == 'Training'"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{clickedData.title}} Details</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      *ngIf="clickedData.title == 'Training' || clickedData.title == 'Document' || clickedData.title == 'E-Sign'"
                      [ngStyle]="{'min-width': '200px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Version</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th *ngIf="clickedData.title == 'Document'" [ngStyle]="{'min-width': '140px','max-width': '140px'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Effective Date</span>
                      </div>
                    </th>

                    <th *ngIf="clickedData.title == 'Document'" [ngStyle]="{'min-width': '140px','max-width': '140px'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Expiration Date</span>
                      </div>
                    </th>
                    <th
                      *ngIf="clickedData.title != 'Training' && !clickedData.title.includes('Forms and Logs') && clickedData.title != 'E-Sign'"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>
                          {{
                          clickedData.title === 'Customer Complaint' ? 'Company Complaint Type' :
                          clickedData.title === 'Quality Issue' ? 'Short Description' :
                          clickedData.title === 'Incident' ? 'Short Description' :
                          clickedData.title + ' Details' }}
                        </span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th *ngIf="clickedData.level == 3"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>{{clickedData.subModule}} Detail</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      *ngIf="clickedData.title !='Forms and Logs Section Data'&& status != 'Locked Overdue' && status != 'Locked'"
                      [ngStyle]="{'min-width': '200px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span> {{getOwnerTitle(clickedData)}} </span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th *ngIf="clickedData.title == 'Audit'"
                      [ngStyle]="{'min-width': '200px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span> Primary Auditee </span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '280px','max-width': '280px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Requester</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1" *ngIf="status != 'Locked Overdue' && status != 'Locked'"
                      [ngStyle]="{'min-width': '140px','max-width': '140px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Requested On</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '140px','max-width': '140px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Pending With</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th
                      *ngIf="clickedData?.title != 'Forms and Logs Section Data' && clickedData?.title != 'Forms and Logs' && clickedData?.title != 'Forms and Logs Template'"
                      [ngStyle]="{'min-width': '140px','max-width': '140px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}"
                      class="sticky-dynamic-col1">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Due Date</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                  </ng-container>
                  <ng-container *ngIf="clickedData.title == 'User Deactivation Approval'">
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>User To be Deactivated</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Pending With/Manager</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>User Status</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Deactivation Approval Req On</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                    <th class="sticky-dynamic-col1"
                      [ngStyle]="{'min-width': '250px','max-width': '250px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
                      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                        <span>Deactivation Approval Req By</span>
                        <div class="d-flex gap-2 align-items-center">
                          <div>
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                          </div>
                        </div>
                      </div>
                    </th>
                  </ng-container>
                  <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tr *ngFor="let task of pagedItems | searchFilter : searchValue;let idx = index;">
                  <td style="min-width: 80px; text-align: center;"
                    *ngIf="task.status == 'Locked' || task.status == 'Locked Overdue(RM Approved)' || task.status == 'Locked Overdue'">
                    <div style="display: flex;">
                      <div [ngClass]="task.searchChildCheckBox ?'static_icon':'hover-menu-icons'">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                      <div style="margin-left: 5px;">
                        <input id="selectedCheckBox" type="checkbox" style="zoom: 1.2;"
                          [checked]="task.searchChildCheckBox" (change)="onChildCheckBoxChanged($event, task, idx)">
                      </div>
                    </div>
                  </td>

                  <td style="width: 60px; text-align: center;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "
                    *ngIf="task.status != 'Locked' && task.status != 'Locked Overdue(RM Approved)' && task.status != 'Locked Overdue'">
                    <div style="display: flex;">
                      <div [ngClass]="task.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                      <div>
                        <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                          (change)="dataGridChildCheckBoxChecked($event, pagedItems, idx)">
                      </div>
                    </div>
                  </td>

                  <ng-container *ngIf="clickedData.title != 'User Deactivation Approval'">
                    <td style="overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title == 'Document' || clickedData.title == 'Instructor Training' || clickedData.title.includes('Forms and Logs') || clickedData.title =='Feedback'">
                      <a href="" (click)="openDetailPage(task,$event)">{{task.taskRefNo}}</a>
                    </td>

                    <td style="overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title != 'Training' && clickedData.title != 'Document' && clickedData.title != 'Instructor Training' && clickedData.title != 'Feedback' && !clickedData.title.includes('Forms and Logs')">
                      <a style="color: blue !important;text-decoration: underline;cursor: pointer;">
                        <span (click)="openAddPopup(task)" (keydown.enter)="openAddPopup(task)">
                          {{task.taskRefNo}}
                        </span>
                      </a>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title == 'Training'">
                      <a href="" (click)="openDetailPage(task,$event)">{{task.taskName}}</a>
                    </td>

                    <td style="overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title == 'Training' || clickedData.title == 'Document'|| clickedData.title == 'E-Sign'">
                      <span>{{task.version}}</span>
                    </td>

                    <td *ngIf="clickedData.title == 'Document'">
                      <span>{{task.effectiveDate | date : appService.getOneQmsDateFormat}}</span>
                    </td>

                    <td *ngIf="clickedData.title == 'Document'">
                      <span>{{task.expirationDate | date : appService.getOneQmsDateFormat}}</span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title != 'Training' && !clickedData.title.includes('Forms and Logs') && clickedData.title != 'E-Sign'">
                      <span>{{task.taskName}}</span>
                    </td>

                    <td style="overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.level == 3">
                      <span>
                        <span *ngIf="task.subTaskName==undefined"></span>
                        <span *ngIf="task.subTaskName">
                          <ng-container *ngIf="clickedData.subModule != 'Followups'">
                            {{task.subTaskName}}
                          </ng-container>
                          <ng-container *ngIf="clickedData.subModule == 'Followups'">
                            <div class="download-button-continer btn-align" mat-dialog-actions>
                              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                (click)="getCLOB(clickedData.subModule, task.subTaskName)">
                                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                  alt="download">
                                <span class="ms-1">View</span>
                              </button>
                            </div>
                          </ng-container>
                        </span>
                      </span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title !='Forms and Logs Section Data'&& status != 'Locked Overdue' && status != 'Locked'">
                      <span>{{task.taskOwnerUserName}}</span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData.title == 'Audit'">
                      <span>{{task.auditee}}</span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>{{task.requesterUserName}}</span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      class="text-uppercase" *ngIf="status != 'Locked Overdue'  && status != 'Locked'">
                      <span>
                        {{task.actionRequestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                      </span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>{{task.pendingWithUserNames}}</span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf="clickedData?.title != 'Forms and Logs Section Data' && clickedData?.title != 'Forms and Logs' && clickedData.title!='Training' && clickedData?.title != 'Forms and Logs Template'"
                      class="text-uppercase">
                      <span>
                        {{task.dueOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                      </span>
                    </td>

                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'"
                      *ngIf=" clickedData.title=='Training'" class="text-uppercase">
                      <span>
                        {{task.dueDate | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container *ngIf="clickedData.title == 'User Deactivation Approval'">
                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <a href="" (click)="openUserPopup(task,$event)">{{task.taskName}}</a>
                    </td>
                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>{{task.pendingWithUserNames}}</span>
                    </td>
                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>{{task.status}}</span>
                    </td>
                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>
                        {{task.actionRequestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                      </span>
                    </td>
                    <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis'; white-space: 'nowrap'">
                      <span>{{task.requesterUserName}}</span>
                    </td>
                  </ng-container>
                </tr>
              </table>
              <div class="d-flex justify-content-center">
                <div class="width-cheat small paginationCell">
                  <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                      {{ showingRowsText }}
                      1-{{ perPage }} of {{ collectionSize | number }}
                    </div>
                    <div>
                      <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                        [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                        [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                        [boundaryLinks]="true" size="sm">
                      </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                      <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                        ngbDropdownToggle>
                        {{ perPage }}
                        <i class="ms-1 fa-solid fa-chevron-down"></i>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                      </div>
                      per page
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="clickedData.subModule == 'Document Withdrawal'">
            <app-document-withdrawal [documentData]="clickedData" (answer)="onAnswer()"></app-document-withdrawal>
          </div>

          <div *ngIf="clickedData.subModule == 'Document Destruction'">
            <app-document-destruction [documentData]="clickedData" (answer)="onAnswer()"></app-document-destruction>
          </div>

          <div *ngIf="clickedData.subModule == 'Document Extension'">
            <app-document-extension [documentData]="clickedData" (answer)="onAnswer()"></app-document-extension>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="message.taskLevelData.subModuleName == 'Actions'">
            <app-actions [activityData]="false"></app-actions>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="message.taskLevelData.subModuleName == 'Preliminary Actions'">
            <app-pre-actions [activityData]="false"></app-pre-actions>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="message.taskLevelData.subModuleName == 'Followup' || message.taskLevelData.subModuleName == 'Followups'">
            <app-au-followups [activityData]="false"></app-au-followups>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="message.taskLevelData.subModuleName=='Effectiveness Check'">
            <app-tasks-ec [activityData]="false"></app-tasks-ec>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="message.taskLevelData.subModuleName=='Extension'">
            <app-task-extensions [activityData]="false"></app-task-extensions>
          </div>

          <div class="form-template ActivityPage" style="margin-top:1%;"
            *ngIf="this.qmsservice.taskModuleName=='AU' && (this.qmsservice.auditEditmodeDatas.pageName=='Annual Audit Schedule'|| this.qmsservice.auditEditmodeDatas.pageName=='Audit Plan')">
            <app-au [activityData]="false"></app-au>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #confirmFindingPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFindings()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-au-finding-details></app-au-finding-details>
  </div>
</ng-template>

<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{title}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row" *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock =='N'">
        Are you sure, you want to unlock the training?
      </div>
      <div class="row" *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock =='Y'">
        <div>
          <label for="username ">User Name</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div>
          <input id="usernameconfirm" style="height: 70% !important;" class="input-filed-continers" type="text"
            [(ngModel)]="displayUserName" disabled>
        </div>
      </div>
      <div class="row" *ngIf="(tmsSettingsObj.esignatureAtTrainingUnlock =='Y' && !isAdenabled)">
        <div>
          <label for="pass ">Password</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div> <input id="pass" style="height: 70% !important;" class="input-filed-continers"
            [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
          <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
            <i
              [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'">
            </i>
          </span>
        </div>
        <span id="pass-required-msg">Please enter password</span>
      </div>
      <div class="row" *ngIf="isShowDueDate">
        <div><label for="username ">Due Date</label><span class="mandatory-symbol">*</span></div>
        <div>
          <input type="text" id="dued" style="height: 70% !important;" class="form-control data-picker-continer"
            bsDatepicker [bsConfig]="pickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="dueDate">
        </div>
        <span id="due-required-msg">Please enter duedate</span>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithFunc()">
        OK
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-6">
          <div>
            <label id="checkRequiredFor-validation" for="email">Check Required For</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCheckRequiredFor"
            (closed)="checkRequiredForTxt=''" (click)="focusmethod('checkRequiredForSearch')"
            (keydown.enter)="focusmethod('checkRequiredForSearch')">
            <input type="search" id="checkRequiredForSearch" class="dropdownsearchstyle"
              [(ngModel)]="checkRequiredForTxt" matInput placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onCheckRequiredForRemoved($event)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of checkRequiredForListDropdown| assessmentSearch :checkRequiredForTxt"
              (onSelectionChange)="onCheckRequiredForSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-6">
          <div>
            <label id="ownerField-validation" for="email">Owner</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedOwner" (closed)="ownerTxt=''"
            (click)="focusmethod('ownerSearch')" (keydown.enter)="focusmethod('ownerSearch')">
            <input type="search" id="ownerSearch" class="dropdownsearchstyle" [(ngModel)]="ownerTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onOwnerRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of ownerListDropdown| assessmentSearch :ownerTxt"
              (onSelectionChange)="onOwnerSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" style="margin-top: 6%;">
        <div class="col-md-6">
          <div>
            <label id="dueDate-validation" for="email">Due Date</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <input id="dueDate" class="form-control data-picker-continer" type="text" bsDatepicker
            [bsConfig]="dueDatePickerConfiguration" [dateCustomClasses]="datepickerDateCustomClasses"
            [(ngModel)]="ecData.dueDate" (ngModelChange)="dueDateOnChanged($event)">
        </div>
        <div class="col-md-6">
          <div>
            <label for="email">Remind N Days Before Due Date</label>
          </div>
          <input class="input-filed-continers" type="number" id="remindNDaysBeforeDueDate"
            (keydown)="validateNumberFields($event)" [(ngModel)]="ecData.remindNDaysBeforeDueDate">
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addFunction(ecData)">
        <i class="fas fa-plus"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelECAddAndEditFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">
      {{ this.clickedData.title == 'User Deactivation Approval' ? this.clickedData.title : status }}
    </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="">
          <div class="row">
            <div class="col-md-12">
              <div class="row" *ngIf="isEsignRequired">
                <div class="col-md-3"><label for="username ">User Name</label></div>
                <div class="col-md-9"> <input id="username" style="height: 80% !important;"
                    class="input-filed-continers" type="text" [(ngModel)]="displayUserName" disabled>
                </div>
              </div>
              <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
                <div class="col-md-3"><label id="password-validation" for="pass">Password</label><span
                    class="mandatory-symbol">*</span></div>
                <div class="col-md-9">
                  <input id="password" style="height: 80% !important;" class="input-filed-continers"
                    [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
                    (focusout)="onPasswordFieldFocusout()" noCopyPaste>
                  <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
                    <i
                      [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label for="email" id="comment-validation">Comments</label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <div class="col-md-9">
                  <textarea id="comment" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="comments"
                    (focusout)="onPasswordFieldFocusout()"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
        {{ this.clickedData.title == 'User Deactivation Approval' ?
        ( this.deactivationDecision == 'approve' ? 'Approve' : 'Reject') : 'Approve' }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #messagePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeMessage()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ status }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="max-height:450px;overflow-y: auto;overflow-x: hidden;">
    <div class="d-flex" *ngFor="let task of messageList; let idx = index;" style="justify-content: center;">
      <div style="padding-top: 1.5%; ">
        <svg width="20" height="20" *ngIf="task.resultType === 'S'" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20" fill="green">
          <path d="M17.293 5.293l-1.414-1.414-6.293 6.293-2.293-2.293-1.414 1.414 3 3 .707.707.707-.707 7-7z" />
        </svg>
        <svg width="20" height="20" *ngIf="task.resultType !== 'S'" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20" fill="red">
          <path
            d="M16 4.343l-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.586 1.414 1.414 4.586-4.586 4.586 4.586 1.414-1.414-4.586-4.586z" />
        </svg>
      </div>
      <div class="mt-2" style="text-align: center;">{{task.result}}</div>
    </div>
  </div>

  <div style="margin: 5px 0px;">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMessage()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #feedbackPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFeedbackFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Feedback - {{feedbackData.taskRefNo}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="max-height:500px;overflow-y: auto;overflow-x: hidden;">
    <div class="row" style="margin: 10px 10px;" *ngIf="feedbackQuestionsList.length > 0">
      {{feedbackQuestionsList[0].templateDescription}}
    </div>
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12">
        <div class="row" *ngFor="let field of feedbackQuestionsList,let i=index;">
          <div class="row" style="margin-bottom:10px;">
            <div class="col-md-5"><label for="name">{{field.questionCode}}.{{field.question}}</label><span
                class="mandatory-symbol">*</span></div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Text Field'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text"
                [(ngModel)]="field.fieldDefaultValue">
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Date Field'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="field.fieldDefaultValue">
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Large Text Field'">
              <textarea attr.id="field{{i}}" type="text" class="input-filed-textarea" rows="4"
                [(ngModel)]="field.fieldDefaultValue"></textarea>
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Drop Down'">
              <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldDefaultValue"
                (closed)="fieldsSearchTxt=''" (click)="focusmethod('focusSearch')"
                (keydown.enter)="focusmethod('focusSearch')">
                <input type="search" attr.id="field{{i}}" class="dropdownsearchstyle" [(ngModel)]="fieldsSearchTxt"
                  matInput placeholder="Search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onFlexifieldSelect(field,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of field.dropDownValues| assessmentSearch :fieldsSearchTxt"
                  (onSelectionChange)="onFlexifieldSelect(field,item)" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode=='Multiselect Drop Down'">
              <mat-select matInput multiple placeholder="Select" #flexifieldValueSelected1
                [(ngModel)]="field.selectedFlexifieldValue" (closed)="flexifieldValueTxt=''"
                (click)="focusmethod('flexifieldValueSearch')" (keydown.enter)="focusmethod('flexifieldValueSearch')">
                <input type="search" id="flexifieldValueSearch" class="dropdownsearchstyle"
                  [(ngModel)]="flexifieldValueTxt" matInput placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="flexifieldValueSelected"
                    (change)="toggleAllSelection('flexifieldValueSelected')">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of field.dropDownValues| multiAssessmentSearchPipe :flexifieldValueTxt"
                  [value]="item1" (onSelectionChange)="onQuesAndAnswSelect($event,item1)">
                  {{ item1 }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Radio Button'">
              <mat-radio-group attr.id="field{{i}}" [(ngModel)]="field.fieldDefaultValue">
                <mat-radio-button *ngFor="let val of field.dropDownValues" [value]="val"
                  (change)="radioBoxChecked(field,$event,val)">{{val}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <div class="col-md-5" *ngIf="field.fieldTypeCode =='Check Box'">
              <div>
                <section *ngFor="let val of field.dropDownValues" attr.id="field{{i}}">
                  <mat-checkbox (change)="checkBoxChecked(field,$event,val)"
                    [checked]="field.checkedCheckBoxValue.indexOf(val) != -1"
                    [disabled]="field.isEditable == 'N'">{{val}}</mat-checkbox>
                </section>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>

  <div style="margin: 5px 0px;">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="saveFeedbackFunc()">
        Save
      </button>
      <button mat-stroked-button class="addButton" (click)="submitFeedbackFunc()">
        Submit
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFeedbackFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #resultPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelResultPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{popupTitle}} </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="table-container" style="margin: 10px;">
      <table style="max-height: 65vh;">
        <thead>
          <th
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Training Name</span>
            </div>
          </th>
          <th
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Name</span>
            </div>
          </th>
          <th
            [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Result</span>
            </div>
          </th>

          <th id="menu1" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
            <td class="row-data">{{ r.userTrainingName }}</td>
            <td class="row-data">{{ r.userName}}</td>
            <td class="row-data" [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
              {{ r.response.result }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #userPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeUserPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">User Deactivation Approval</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="border:0.2px solid rgb(235, 232, 232);" class="p-1 m-2">
      <div class="form-continer" style="max-height: 500px !important">
        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
          <button mat-stroked-button class="addButton" (click)="verifyUser('approve')">
            <i class="fa fa-check"></i>&nbsp;Approve</button>
          <button mat-stroked-button class="addButton" (click)="verifyUser('reject')">
            <i class="fa fa-times"></i>&nbsp;Reject</button>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div>
              <label for="email ">{{dynamicLabel['USER_NAME']}}</label>
            </div>
            <div *ngIf="!user.isAdUser">
              <input id="userName" class="input-filed-continers uppercase" type="text" [disabled]="true"
                [(ngModel)]="user.userName">
            </div>
            <div *ngIf="user.isAdUser">
              <input [disabled]="true" id="emailId" class="input-filed-continers" type="email"
                [(ngModel)]="user.emailAddress">
            </div>
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['FIRST_NAME']}}</label>
            </div>
            <input id="firstName" class="input-filed-continers" type="text" [(ngModel)]="user.firstName"
              [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['LAST_NAME']}}</label>
            </div>
            <input id="lastName" class="input-filed-continers" type="text" [(ngModel)]="user.lastName"
              [disabled]="true">
          </div>
          <div class="col-md-3">
            <div><label for="email">Contact Number</label></div>
            <input id="contactNumber" class="input-filed-continers" type="number" min="1"
              [(ngModel)]="user.contactNumber" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['EMAIL_ADDRESS']}}</label>
            </div>
            <input class="input-filed-continers" type="email" [(ngModel)]="user.emailAddress" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">Is AD User</label>
            </div>
            <mat-slide-toggle color="primary" name="aduser" [disabled]="true" [(ngModel)]="user.isAdUser">
              <ng-container *ngIf="user.isAdUser; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['MANAGER_NAME']}}</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.managerName" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['DESIGNATION']}}</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.designation" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['DEPARTMENT']}}</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.department" [disabled]="true">
          </div>
          <div class="col-md-6">
            <div>
              <label for="email">{{dynamicLabel['TIMEZONE']}}</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.timezone" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">Country</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.countryName" [disabled]="true">
          </div>

          <div class="col-md-3">
            <div>
              <label for="email">City</label>
            </div>
            <input id="city" class="input-filed-continers" type="text" [(ngModel)]="user.city" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">Primary Language</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="user.primaryLanguage" [disabled]="true">
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['IS_ACTIVE']}}</label>
            </div>
            <mat-slide-toggle color="primary" name="aduser" [disabled]="true" [(ngModel)]="user.isActive">
              <ng-container *ngIf="user.isActive; else no">
                <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #no>
                <span style="color: red;">No</span>
              </ng-template>
            </mat-slide-toggle>
          </div>
          <div class="col-md-3">
            <div>
              <label for="email">{{dynamicLabel['CLIENT_EMPLOYEE_ID']}}</label>
            </div>
            <input class="input-filed-continers" type="text" [(ngModel)]="user.clientEmployeeId" [disabled]="true">
          </div>
          <div class="col-md-3 ">
            <div>
              <label for="joining-date">{{dynamicLabel['JOINING_DATE']}}</label>
            </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="commonDateConfig"
              [dateCustomClasses]="dateCustomClasses" [(ngModel)]="user.joiningDate" [disabled]="true">
          </div>
          <div class="col-md-3 ">
            <div>
              <label for="relieving-date">{{dynamicLabel['RELIEVING_DATE']}}</label>
            </div>
            <input type="text" id="relieve" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="user.relievingDate"
              [disabled]="true">
          </div>
          <div class="col-md-6">
            <div>
              <label for="email">User Description</label>
            </div>
            <textarea id="userDescription" type="text" class="input-filed-textarea" rows="4" cols="50"
              [(ngModel)]="user.userDescription" [disabled]="true"></textarea>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>

<app-editor #clobViewPopup></app-editor>